import PageLayout from 'bee-page-layout'

export default PageLayout
